import React from "react";
import NetworkError from "@/components/NetworkError";
import "./index.less";

function RouteError() {
  return (
    <main className="route-error">
      <NetworkError onRetry={() => window.location.reload()} />
    </main>
  );
}

export default RouteError;
